import { AddBankAccountModal } from "@features/AddBankAccountModal/AddBankAccountModal";
import { useModalStore } from "@store/modal/modal";

export const useNewBankAccountModal = () => {
  const { create } = useModalStore();

  return (preselectedBankId?: number) => {
    create((modalProps) => (
      <AddBankAccountModal
        preselectedBankId={preselectedBankId}
        {...modalProps}
      />
    ));
  };
};
